import '../../../Content/Styles/utrke-widget.less';
import { WebSocketContext } from '../Game/WSContext.jsx'
import React, { useEffect, useState, useContext } from "react";
//import Clock from "../content/Clock.png";
//import Person from "../content/Person.png";
//import Medal from "../content/Medal.png";


export default function UtrkeWidgetTab({ gameID, playerID }) {
    const [ready, val, send, connectionError] = useContext(WebSocketContext);
    const [results, setResults] = useState([]);
    const [tournament, setTournament] = useState(null);
    const [remainingTime, setRemainingTime] = useState();
    const [isLoading, setIsLoading] = useState(true)
    const [minResults, setMinResults] = useState([]);

    useEffect(() => {
        if (ready && !connectionError) {
            send(JSON.stringify({ type: "subscribe", topic: "leaderboard", data: { gameID: gameID, playerID: playerID } }));
            send(JSON.stringify({ type: "tournament", data: { playerID: playerID, limit: 50, gameID: gameID } }));


        }
    }, [ready, connectionError])


    useEffect(() => {
        if (val != null) {
            parseData(val);
        }
    }, [val])


    useEffect(() => {

        if (tournament != null) {
            setRemainingTime(getRemainingTime(tournament.endTimeUTC))
            var interval = setInterval(() => {

                setRemainingTime(getRemainingTime(tournament.endTimeUTC))
            }, 10000)

        }

        return () => { clearInterval(interval) }
    }, [tournament])

    function getRemainingTime(time) {
        
        const now = new Date();
        const endTime = new Date(time + 'Z');

        const diffMs = endTime - now;
        if (diffMs <= 0) {
            return 0;
        }
        var totalMinutes = Math.floor(diffMs / (1000 * 60));
        const days = Math.floor(totalMinutes / (60 * 24));
        totalMinutes -= days * (60 * 24);
        const hours = Math.floor(totalMinutes / 60);
        totalMinutes -= hours * (60);
        const minutes = totalMinutes;

        if (days > 0) {
            return `${days}d ${hours}h ${minutes}m`;
        }
        else if (hours > 0) {

            return `${hours}h ${minutes}m`;
        }
        return `${minutes}m`
    }

    function parseData(data) {
        var x = JSON.parse(data);
        switch (x.type) {
            case "leaderboardResponse":
                setResults(x);
                if (x.length !== 0 && x.data.length != 0) {
                    const playerResultIndex = x.data.findIndex(x => x.isMe);
                    //ako je manje od 3 rezultata, zemi sve
                    if (x.data.length <= 3) {
                        setMinResults(x.data);
                    }
                    //ako je vise, onda gledam koje 3 uzimam
                    else {
                        if (playerResultIndex !== -1) {
                            // uzimam 3 rezultata
                            let start = playerResultIndex - 1;
                            let end = playerResultIndex + 2;
                            //edge case ako je igrac prvi
                            if (start < 0) {
                                start = 0;
                                end = 3;
                            }
                            //edge case ako je igrac zadnji
                            if (end > x.data.length) {
                                end = x.data.length;
                                start = x.data.length - 3;
                            }
                            setMinResults(x.data.slice(start, end));
                        }
                        else {
                            setMinResults(x.data.slice(x.data.length - 3, x.data.length));
                        }
                    }
                }
                break;
            case "tournamentResponse":
                setTournament(x.data[0]);
                setIsLoading(false)
                break;
            default:
                break;
        }

    }


    return (
        <>
            {!isLoading && tournament != null && < div className="partner-container">
                <div className="main-title">Turniri igre</div>
                <img className="tournament-image" src={tournament.image} />
                <div className="tournament-name">{tournament.tournamentName}</div>
                <div className="tournament-description" dangerouslySetInnerHTML={{ __html: tournament.description }}></div>
                <div className="tournament-reward-sum-container">
                    <div className="tournament-reward-sum-text">Nagrade ukupno:</div>
                    <div className="tournament-reward-sum">{tournament.rewardSum} €</div>
                </div>
                <div className="tournament-info-container">
                    <div className="tournament-info-text">Turnir traje još</div>
                    <div className="tournament-info-right green">
                        <span className="clock-icon"></span>
                        <div className="tournament-info-number">{remainingTime}</div>
                    </div>
                </div>
                <div className="tournament-info-container">
                    <div className="tournament-info-text">Sudjeluje u turniru</div>
                    <div className="tournament-info-right blue">
                        <span className="person-icon"></span>
                        <div className="tournament-info-number">{results?.data?.length}</div>
                    </div>
                </div>
                {results && results.data?.find(x => x.isMe) && <div className="tournament-info-container">
                    <div className="tournament-info-text">Trenutna pozicija</div>
                    <div className="tournament-info-right yellow">
                        <span className="medal-icon"></span>
                        <div className="tournament-info-number">{results && results.data?.find(x => x.isMe)?.rank}</div>
                    </div>
                </div>}
                <div className="tournament-leaderboard-container">
                    <ol>
                        <li className="tournament-result-text">
                            <p>Plasman</p>
                            <p>Alias</p>
                            <p>Bodovi</p>
                        </li>
                        {minResults && minResults.map((x, i) => {
                            return (
                                <li className={x.isMe ? "tournament-result me" : "tournament-result"}>
                                    <div>{x.rank}.</div>
                                    <div key={i}> {x.name}</div>
                                    <div ><b>{x.points}</b></div>
                                </li>
                            )
                        })}
                    </ol>
                </div>
            </div>}
            {(!isLoading || connectionError) && tournament == null &&
                <div className="no-tournament-container">
                    <div className="main-title">Turniri i promocije</div>
                    <img className="no-tournament-img" src={"https://cdn.supersport.hr/IHG/NoTournaments.png"} />
                    <div className="tournament-info-text-no-tournament-top">Nema aktivnih turnira ni promocija</div>
                    <div className="tournament-info-text-no-tournament-bottom">Ova igra trenutačno ne sudjeluje ni u jednom turniru ni promociji. Dok čekaš novu priliku pogledaj ostale igre, turnire i promocije koje su trenutno aktivne ili nastavi zabavu i osvajanje dobitaka u ovoj igri.</div>
                </div>
            }
        </>

    )
}